import ChangePasswordForm from "./change-password-form";

export default ChangePasswordForm;